import type { AuthUserProfile } from '@/stores/auth-store';

export type CanonicalAuthProfile = Omit<AuthUserProfile, 'id' | 'email'> & {
  kind: 'active';
  authActorId: string;
  canonicalUserId: string;
  isActive: true;
  status: 'ACTIVE';
};

export type CanonicalAuthResult =
  | CanonicalAuthProfile
  | {
      kind: 'blocked';
      authActorId: string;
      reason: 'inactive' | 'missing' | 'missing-role';
      role?: never;
      tenantId?: never;
    }
  | { kind: 'unavailable'; role?: never; tenantId?: never };

export type CanonicalUserRow = {
  id: string;
  auth0_id: string;
  first_name: string | null;
  last_name: string | null;
  role: string | null;
  tenant_id: string | null;
  is_active: boolean | null;
  status: string | null;
};

export const CANONICAL_AUTH_SELECT =
  'id, auth0_id, first_name, last_name, role, tenant_id, is_active, status';

/** An actor binding and both active predicates are required, even with service-role reads. */
export function canonicalAuthResult(row: CanonicalUserRow, actorId: string): CanonicalAuthResult {
  if (row.auth0_id !== actorId || !row.id) return { kind: 'unavailable' };
  if (row.is_active !== true || row.status !== 'ACTIVE') {
    return { kind: 'blocked', authActorId: actorId, reason: 'inactive' };
  }
  if (!row.tenant_id) return { kind: 'blocked', authActorId: actorId, reason: 'missing' };
  if (!row.role) return { kind: 'blocked', authActorId: actorId, reason: 'missing-role' };
  return {
    kind: 'active',
    authActorId: actorId,
    canonicalUserId: row.id,
    isActive: true,
    status: 'ACTIVE',
    firstName: row.first_name ?? '',
    lastName: row.last_name ?? '',
    role: row.role,
    tenantId: row.tenant_id,
  };
}
